export const SERVER = 'https://api.gameif.media/';
// export const SERVER = 'https://api-app-dev.gameif.media/';
// export const SERVER = 'http://localhost:9090/';
// export const SERVER = 'https://api-dev.gameif.media/';

export const ENDPOINT = `${SERVER}v1/app/`;

export const VERSION = '3.4.13';

export const STORES = {
  IOS: 'https://itunes.apple.com/us/app/gameif/id1413309011?l=es&ls=1&mt=8',
  ANDROID: 'https://play.google.com/store/apps/details?id=com.gameif.loftpublicidad',
  WEB: 'https://gameif.media'
};

export const ASSETS = {
  AVATAR_PLAYER: `${SERVER}s3/`,
  IMAGE_QUESTIONS: `${SERVER}s3/preguntas/`,
  ICONS_CATEGORIES: `${SERVER}public/icons-categories/`,
  ICONS_ACHIEVEMENTS: `${SERVER}public/icons-achievements/`,
  PATH_LOGO: `${SERVER}s3/logo/`,
}

export const AUTH = {
  LOGIN: `${ENDPOINT}auth/login`,
  VERIFY: `${ENDPOINT}auth/verify`,
  DEVICE_INFO: `${ENDPOINT}auth/device-info`,
  CHECK_VERSION: `${ENDPOINT}auth/check-version`,
  DOWNLOAD_AVATAR: `${ENDPOINT}auth/avatar/`,
  SET_AVATAR: `${ENDPOINT}auth/set-avatar/`,
  SET_AVATAR_V2: `${ENDPOINT}auth/set-avatar/v2/`,
  UPDATE_PLAYER_ID: `${ENDPOINT}auth/player-id/`,
  SET_PASSWORD: `${ENDPOINT}auth/set-password/`,
  RECUPERAR_CONTRASENIA: `${ENDPOINT}auth/password-recovery`,
  AREAS_JUGADOR: `${ENDPOINT}auth/areas/`,
}

export const DESAFIO_PERSONAL = {
  SUGERENCIAS: `${ENDPOINT}retos-personales/sugerencias/`,
  ALEATORIO: `${ENDPOINT}retos-personales/aleatorio/`,
  DIRECTO: `${ENDPOINT}retos-personales/directo/`,
  ACTUALIZA: `${ENDPOINT}retos-personales/actualiza/`,
  EN_CURSO: `${ENDPOINT}retos-personales/en-curso/`,
  CADUCADOS: `${ENDPOINT}retos-personales/caducados/`,
  MI_TURNO: `${ENDPOINT}retos-personales/mi-turno/`,
  PRIMER_DESAFIO: `${ENDPOINT}retos-personales/primer-desafio/`,
  SCORE: `${ENDPOINT}retos-personales/score/`,
  BUSCAR_JUGADOR: `${ENDPOINT}retos-personales/buscar/`,
  PUEDE_RETAR: `${ENDPOINT}retos-personales/puede-retar/`,
  RETO_BOT: `${ENDPOINT}retos-personales/bot/`,
  SAVE_STATS_BOT: `${ENDPOINT}retos-personales/bot/estadisticas`,
}

export const DESAFIO_EQUIPO = {
  ESTATUS: `${ENDPOINT}retos-equipo/estatus/`,
  SIGUIENTE_RONDA: `${ENDPOINT}retos-equipo/siguiente-ronda/`,
  TABLERO: `${ENDPOINT}retos-equipo/tablero/`,
  GUARDA_ESTADISTICA: `${ENDPOINT}retos-equipo/guarda-estadistica/`
}

export const DASHBOARD = {
  ESTADISTICAS: `${ENDPOINT}estadisticas/`,
  ESTADISTICAS_RETOS: `${ENDPOINT}estadisticas/retos/`,
  ESTADISTICAS_PREGUNTAS: `${ENDPOINT}estadisticas/preguntas/`,
  ESTADISTICAS_EFECTIVIDAD: `${ENDPOINT}estadisticas/efectividad/`,
  ESTADISTICAS_CATEGORIAS: `${ENDPOINT}estadisticas/categorias/`,
  ESTADISTICAS_COPAS: `${ENDPOINT}estadisticas/copas/`,
  CATEGORIAS: `${ENDPOINT}estadisticas/detalle-categorias/`,
  LEADERBOARD: `${ENDPOINT}estadisticas/leaderboard/`,
  MAS_RETOS_JUGADOS: `${ENDPOINT}estadisticas/mas-retos-jugados/`,
  MAS_RETOS_GANADOS: `${ENDPOINT}estadisticas/mas-retos-ganados/`,
  MAS_RETOS_PERDIDOS: `${ENDPOINT}estadisticas/mas-retos-perdidos/`,
  VS: `${ENDPOINT}estadisticas/vs/`,
  DETALLE_RONDA: `${ENDPOINT}estadisticas/detalle-ronda/`,
  HISTORIAL_RETOS: `${ENDPOINT}estadisticas/historico-retos/`,
  EXISTE_HISTORIAL_RETOS: `${ENDPOINT}estadisticas/existe-historico-retos/`,
}

export const ACHIEVEMENTS = {
  LISTA: `${ENDPOINT}insignias/`,
  NUEVOS_LOGROS: `${ENDPOINT}insignias/nuevas-insignias/`
}

export const CAMPAIGN = {
  ACTIVE: `${ENDPOINT}retos-personales/campaigns/active/`,
  ESTADISTICAS: `${ENDPOINT}estadisticas/campaigns/mis-estadisticas/`
}

export const CERTIFICADOS = {
  GET: `${ENDPOINT}certificados/`,
}

export const BUSQUEDA_TESORO = {
  ACTIVA:                `${ENDPOINT}busqueda-tesoro/`,
  HISTORIAL:             `${ENDPOINT}busqueda-tesoro/historial/`,
  NIVELES_USUARIO:       `${ENDPOINT}busqueda-tesoro/niveles/`,
  SELECCIONA_SEDE:       `${ENDPOINT}busqueda-tesoro/agrega-seleccion`,
  OBTEN_PREGUNTAS_NIVEL: `${ENDPOINT}busqueda-tesoro/preguntas/`,
  ACTUALIZA_ESTADISTICAS:`${ENDPOINT}busqueda-tesoro/actualiza-estadisticas`,
  TESORO:                `${ENDPOINT}busqueda-tesoro/tesoro/`,
}

export const MATERIALES_APOYO = {
  GET: `${ENDPOINT}materiales-apoyo/`,
  GET_ONE: `${ENDPOINT}materiales-apoyo/material/`,
  VISTO: `${ENDPOINT}materiales-apoyo/visto`,
  LIKE: `${ENDPOINT}materiales-apoyo/like/`,
}

export const NOTIFICACIONES = {
  GET: `${ENDPOINT}notificaciones/`,
}



// WEBPACK FOOTER //
// ./src/environment/environment.ts